import { useMutation, useQueryClient } from "@tanstack/react-query";
import { promotionApi } from "../services/promotion.api";
import {
  errorNotification,
  successNotification,
} from "../../../utils/notification";
import {
  PROMOTION_MESSAGES_ERROR,
  PROMOTION_MESSAGES_SUCCESS,
} from "../constants/messages";

export const useEnablePromotion = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => promotionApi.enable(id),
    onSuccess: (res) => {
      if (!res.ok) {
        errorNotification(PROMOTION_MESSAGES_ERROR.ENABLE_ERROR);
        return;
      }
      successNotification(PROMOTION_MESSAGES_SUCCESS.ENABLE_SUCCESS);
      queryClient.invalidateQueries({ queryKey: ["promotions"] });
    },
    onError: () => {
      errorNotification(PROMOTION_MESSAGES_ERROR.ENABLE_ERROR);
    },
  });
};

export const useDisablePromotion = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => promotionApi.disable(id),
    onSuccess: (res) => {
      if (!res.ok) {
        errorNotification(PROMOTION_MESSAGES_ERROR.DISABLE_ERROR);
        return;
      }
      successNotification(PROMOTION_MESSAGES_SUCCESS.DISABLE_SUCCESS);
      queryClient.invalidateQueries({ queryKey: ["promotions"] });
    },
    onError: () => {
      errorNotification(PROMOTION_MESSAGES_ERROR.DISABLE_ERROR);
    },
  });
};
